import { useAuth } from "react-oidc-context";

function App() {
  const auth = useAuth();

  const signOutRedirect = () => {
    const clientId = "4e9e7i4i49g8ucanu7j4ebgbqs";
    const logoutUri = "https://dashboard.appadvent.in";
    const cognitoDomain = "https://cw-db-491847173898.auth.us-east-1.amazoncognito.com";
    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  if (auth.isLoading) {
    return <div style={{ textAlign: "center", marginTop: "50px" }}>Loading...</div>;
  }

  if (auth.error) {
    return <div style={{ textAlign: "center", marginTop: "50px", color: "red" }}>Encountering error... {auth.error.message}</div>;
  }

  // Jab user successfully login ho jaye
  if (auth.isAuthenticated) {
    return (
      <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif", marginTop: "50px" }}>
        <h2>Welcome, {auth.user?.profile.email}!</h2>
        <p style={{ color: "green" }}> successfully custom portal authenticated .</p>

        {/* AWS CloudWatch Dashboard ka direct link */}
        <div style={{ margin: "30px 0" }}>
          <a 
            href="https://cloudwatch.amazonaws.com/dashboard.html?dashboard=Goalkick_logs&context=eyJSIjoidXMtZWFzdC0xIiwiRCI6ImN3LWRiLTQ5MTg0NzE3Mzg5OCIsIlUiOiJ1cy1lYXN0LTFfMmE0WFpLT25oIiwiQyI6IjRlOWU3aTRpNDlnOHVjYW51N2o0ZWJnYnFzIiwiSSI6InVzLWVhc3QtMTo4ZmI5YmNkNi00ZWMxLTQxYTQtODM4Yi0zODNlYzA1NWRmODYiLCJPIjoiYXJuOmF3czppYW06OjQ5MTg0NzE3Mzg5ODpyb2xlL3NlcnZpY2Utcm9sZS9DV0RCU2hhcmluZy1SZWFkT25seUFjY2Vzcy1RV044WDhPRyIsIk0iOiJVc3JQd1NpbmdsZSJ9" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <button style={{ padding: "12px 24px", fontSize: "16px", backgroundColor: "#FF9900", color: "#ffffff", border: "none", cursor: "pointer", borderRadius: "5px", fontWeight: "bold" }}>
              View Goalkick_logs Dashboard
            </button>
          </a>
        </div>

        <button onClick={() => signOutRedirect()} style={{ padding: "8px 16px", backgroundColor: "#d9534f", color: "#ffffff", border: "none", cursor: "pointer", borderRadius: "4px" }}>
          Sign out
        </button>
      </div>
    );
  }

  // Jab user login na ho
  return (
    <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif", marginTop: "100px" }}>
      <h2>CloudWatch Dashboard Portal</h2>
      <p>Please click the below link URL:</p>
      <button onClick={() => auth.signinRedirect()} style={{ padding: "12px 24px", fontSize: "16px", backgroundColor: "#0275d8", color: "#ffffff", border: "none", cursor: "pointer", borderRadius: "5px", fontWeight: "bold" }}>
        Sign in with Custom Domain
      </button>
    </div>
  );
}

export default App;
